<template>
  <div class="template">
    <!-- 搜索区域 -->
    <div class="search">
      <div class="search-center">
        <!-- 订单号搜索 -->
        <div class="search-item">
            <Input clearable
            v-model="search.orderNo"
            placeholder="订单号"
            style="width: 150px;"
            ></Input>
        </div>
        <!-- 支付单号搜索 -->
        <div class="search-item">
            <Input clearable
            v-model="search.payNo"
            placeholder="支付单号"
            style="width: 150px;"
            ></Input>
        </div>
        <!-- 支付平台单号搜索 -->
        <div class="search-item">
            <Input clearable
            v-model="search.tradeNo"
            placeholder="交易号"
            style="width: 150px;"
            ></Input>
        </div>
        <!-- 支付平台单号搜索 -->
        <div class="search-item">
            <Input clearable
            v-model="search.refundNo"
            placeholder="退款单号"
            style="width: 150px;"
            ></Input>
        </div>
        <!-- 状态筛选 -->
        <div class="search-item">
            <Select clearable
                style="width:100px;"
                v-model="search.type"
                :label-in-value="true"
                placeholder="状态"
                class="select"
              >
             <Option value="1" label="付款"></Option>
             <Option value="2" label="退款"></Option>
            </Select>
        </div>        
        <!-- 查询按钮 -->
        <Button
          style="width: 80px;margin-right: 10px;margin-bottom:5px"
          type="primary"
          icon="ios-search"
          @click="searchFn"
          >查询</Button>
      </div>    
    </div>

    <!-- 表格区域 -->
    <div class="table">
      <Table
        :columns="diyData.columns"
        :data="apiData.tableList"
      >
        <!-- 分页器 -->
        <template slot="footer">
             <Page
            :total="apiData.total"
            show-total
            :page-size="search.pageSize"
            :current="search.pageNo"
            @on-change="pageChange"
            @on-page-size-change="pageSizeChange"
            class-name="footer-page"
            show-elevator
            show-sizer
          ></Page>
        </template>
      </Table>
    </div>
  </div>
</template>

<script>
import {orderpayrefundList} from '@/api/payment-details.js'
import { getDateTime } from '@/libs/util'
export default {
  name: 'points-details',
  data () {
    return {
        // 路由查询参数
        query:{},
      // 搜索条件对象
      search: {
        orderNo:'',      // 订单号
        payNo:'',        // 支付单号
        tradeNo:'',      // 支付平台单号
        type:'',       // 支付状态
        pageNo: 1,       // 当前页码
        pageSize: 10,    // 每页条数
      },
      // 弹窗控制
      diyDom:{
        showModal:false
      },
      // 表格配置数据
      diyData: {
        columns: [
           // 商户号列
           {
            title: '商户号',
             width:'200px',
            key:'mchId',
          },
          // 订单号/支付单号列
          {
            title: '订单号/支付单号',
            width:'260px',
           render: (h, params) => {
              return h('div', [
                h('p', params.row.orderNo),
                 h('p', params.row.payNo),
              ])
             }
          },
          // 支付平台单号列
          {
            title: '支付平台单号',
            width:'280px',
            key: 'tradeNo',
          },
          // 退款单号
          {
            title: '退款单号',
            width:'280px',
            key: 'refundNo',
          },
          // 金额列
          {
            title: '金额',
             width:'100px',
            key: 'amount',
          },
          // 退款列
        //   {
        //     title: '退款',
        //      width:'100px',
        //     key: 'refundAmount',
        //   },
          // 状态列
          {
            title: '状态',
             width:'100px',
             key: 'type',
             render: (h, params) => {
              var html = [
                h('span',params.row.type==1?'付款':params.row.type==2?'退款':'--')
              ]
              return html
             }
          },
  
          // 完成时间
          {
            title: '完成时间',
            width:'180px',
            key: 'completeTime',
          },
          // 空列（用于表格布局）
           {
            title: ' ',
          }
        ]
      },
      // API数据
      apiData: {
        total: 0,        // 总条数
        tableList: [],   // 表格数据
      }
    }      
  },
  methods: {
    // 页码改变处理
    pageChange (e) {
      this.search.pageNo = e
      this.getTableList()
    },
    // 每页条数改变处理
    pageSizeChange (e) {
      this.search.pageSize = e
      this.search.pageNo = 1
      this.getTableList()
    },
    // 搜索处理
    searchFn () {
      this.search.pageNo = 1
      this.getTableList()
    }, 
    // 获取表格数据
    getTableList(){
      this.$store.commit('setSpinShow', true)  // 显示加载状态
      var opt = { ...this.search, ...this.query }
      
      // 处理日期范围参数
      if (this.search.dateRange && this.search.dateRange.length === 2) {
        opt.createTimeBegin = getDateTime(this.search.dateRange[0])
        opt.createTimeEnd = getDateTime(this.search.dateRange[1])
      }
      delete opt.dateRange

      // 调用API获取数据
      orderpayrefundList(opt).then((res) => {
        const {
          list,
          totalCount
        } = res.data
        
        this.apiData.tableList = list
        this.apiData.total = totalCount
      }).finally(() => this.$store.commit('setSpinShow', false))
    },
  },
  // 组件挂载时执行
  mounted () {
    this.query = this.$route.query  // 获取路由查询参数
    this.getTableList()             // 获取表格数据
  },
}
</script>

<style scoped lang="less">
.template{
  width: 100%;
  background: #fff;
  padding: 20px;
  box-sizing: border-box;
}
.button-border{
  margin-right: 10px;
}
</style>
 